import { Toaster as Sonner, type ToasterProps } from 'sonner';

import { useAppearanceStore } from '@/stores/appearance';

/**
 * Toast host.
 *
 * Reads the appearance store directly so toasts follow light/dark without the
 * caller having to pass a theme, and so they stay correct when the user switches
 * appearance with a toast already on screen.
 */
function Toaster({ ...props }: ToasterProps) {
    const appearance = useAppearanceStore((state) => state.appearance);

    return (
        <Sonner
            theme={appearance}
            className="toaster group"
            style={
                {
                    '--normal-bg': 'var(--popover)',
                    '--normal-text': 'var(--popover-foreground)',
                    '--normal-border': 'var(--border)',
                } as React.CSSProperties
            }
            {...props}
        />
    );
}

export { Toaster };
